import React, { useState } from 'react'

import { AssetInformationModal } from '@/components/core-v2'

import { useOrdersFiltersContext } from '../assets-filter-list/orders-filter-context'
import { OrdersDetailEmptyState } from '../orders-detail-empty-state/orders-detail-empty-state'
import { GroupedTabsPanel } from './grouped-tabs-panel'
import { OrdersConfirmed } from './orders-confirmed'
import { OrdersHeader } from './orders-header'
import { OrdersOutstanding } from './orders-outstanding'

export const OrdersDetail = () => {
  const { asset } = useOrdersFiltersContext()
  const [showModal, setShowModal] = useState(false)

  if (!asset) return <OrdersDetailEmptyState />

  return (
    <section>
      <AssetInformationModal
        assetId={asset.assetId}
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />
      <OrdersHeader showModal={() => setShowModal(true)} />
      <GroupedTabsPanel
        label="asset-details"
        tabs={[
          {
            component: <OrdersOutstanding assetId={asset.assetId} />,
            heading: 'Outstanding orders',
            value: 'outstanding'
          },
          {
            component: <OrdersConfirmed assetId={asset.assetId} />,
            heading: 'Confirmed orders',
            value: 'confirmed'
          }
        ]}
      />
    </section>
  )
}
